window.Products.Embroidery.Snapback = function() {};
window.Products.Embroidery.Snapback.texturesLoading = false;
window.Products.Embroidery.Snapback.texturesLoaded = 0;
window.Products.Embroidery.Snapback.inherits(window.Products.Embroidery.Embroidery);
window.Products.Embroidery.Snapback.id = 200;
window.Products.Embroidery.Snapback.slug = 'snapback';

window.Products.Embroidery.Snapback.prototype.set3dProperties = function (modelViewer) {
	var me = this;

	if(!me.texturesLoading && !me.texturesLoaded){
		me.loadTextures(function(){
			// Remove default lights
			modelViewer.scene.remove(modelViewer.camera_light);
			modelViewer.scene.remove(modelViewer.ambient_light);

			// Add new cool light setup
			hemiLight = new THREE.HemisphereLight( 0xcce0ff, 0xffe9cc, 0.6 );
			hemiLight.position.set( 0, 50, 0 );
			modelViewer.scene.add( hemiLight );
			modelViewer.ambient_light = hemiLight;

			dirLight = new THREE.DirectionalLight( 0xfff4e5, 1 );
			dirLight.position.multiplyScalar( 30 );
			modelViewer.scene.add( dirLight );
			modelViewer.camera_light = dirLight;

			// Place objects
			modelViewer.object.position.y = 0.02;

			me.loadEnvMap(function(){
				modelViewer.object.children[5].material.envMap = me.envMap;
				modelViewer.object.children[5].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
				modelViewer.object.children[5].material.reflectivity = 0.5;
				modelViewer.object.children[5].material.needsUpdate = true;
				modelViewer.object.children[5].material.envMap.needsUpdate = true;
			});

			// Load texture
			me.updateThreeTexture(modelViewer);

			// Setup cam and embroidery
			modelViewer.setFixedView('front');
			modelViewer.camera.position.y = 0.2;
			if(!modelViewer.inlab){
				modelViewer.camera.position.z = 0.5;
			}

			// Add fake thickness to embroidery object
			var clone = modelViewer.object.children[9].clone();
			modelViewer.scene.add(clone);
			//clone.position.z = 0.0002;
			clone.scale.z = 1.005;
			clone.position.y = 0.02;
			clone = modelViewer.object.children[9].clone();
			modelViewer.scene.add(clone);
			//clone.position.z = 0.0004;
			clone.scale.z = 0.995;
			clone.position.y = 0.02;
		});
	}
};

window.Products.Embroidery.Snapback.prototype.loadTextures = function(callback){
	var product = this;
	var sources = [   
		'textures/camo.jpg',
		'textures/snapback_heather.jpg',
		'textures/snapback_alpha.jpg'
	];
	product.texturesLoading = true;
	product.texturesLoaded = 0;
	product.textures = [];
	sources.forEach(function(src, index) {
		var textureLoader = new THREE.TextureLoader();
		textureLoader.crossOrigin = 'anonymous';

		var texture = textureLoader.load(THREE_JSON_URL + src, function(event){
			product.textures[index] = event;
			product.texturesLoading = false;
			product.texturesLoaded++;
			if(callback && product.texturesLoaded == sources.length){
				callback();
			}
		});
	});
};

window.Products.Embroidery.Snapback.prototype.setThreeControls = function (controls) {
	controls.minDistance = 0.4;
	controls.maxDistance = 0.8;
};

window.Products.Embroidery.Snapback.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[9].material.map = modelViewer.texture;
	modelViewer.object.children[9].material.bumpMap.minFilter = THREE.LinearMipMapLinearFilter;
	modelViewer.object.children[9].material.bumpScale = 0.0005;
	modelViewer.object.children[9].material.map.minFilter = THREE.LinearMipMapLinearFilter;
	modelViewer.object.children[9].material.transparent = true;
	modelViewer.object.children[9].material.alphaMap = modelViewer.product.textures[2];
	modelViewer.object.children[9].material.needsUpdate = true;
};

window.Products.Embroidery.Snapback.prototype.getEditableOptions = function(){
	return ["color", "embroidery-puff"];
};

window.Products.Embroidery.Snapback.prototype.getEditableOptionsNames = function(){
	return [__("create_ns_option.color"), __("create_ns_option.embroidery-puff")];
};

window.Products.Embroidery.Snapback.prototype.getEditableOptionsExtra = function(_option, _container){
	var me = this;
	switch(_option) {
		case "color":
			return '';
		case "embroidery-puff":
			var out = '<hr>';

			var $switch = _container.find(' .switch').find('input');
			$switch.on('click.extra', function(){
				var enabled = $(this).is(':checked');
				if(!enabled) {
					_container.find('input[type=radio]').attr('disabled', true).attr('checked', false);
				} else {
					var first = _container.find('input[type=radio]').attr('disabled', false).get()[0];
					if(first) first.checked = true;
				}
			});

			$('#layer_properties_panel').on('change.extra', '.colors_container input', function(){
				me.updatePuffOption();
			});

			out += '<p class="warning">' + __('Optional puff embroidery costs an extra 2.75$ and is only available for text and large shapes, if your design does not support it, you will be refunded and the option will be disabled for you.') + '</p>';
			out += '<div id="option_embroidery-puff_colors">' + this.getPuffOption() + '</div>';

			return out;
		default:
			return '';
	}
};

window.Products.Embroidery.Snapback.prototype.getPuffOption = function(){
	var out = '';

	var colors = DesignLab.instance.layerPropertiesManager.getAllColors();
	if(colors.length && DesignLab.instance.lockedScenes.indexOf(DesignLab.instance.scene) == -1){
		$('#container_options_embroidery-puff').find('.switch').find('input').attr('disabled', false);
	} else {
		$('#container_options_embroidery-puff').find('.switch').find('input').attr('disabled', true);
	}

	var enabled = $('#container_options_embroidery-puff').find('.switch').find('input').is(':checked') && !$('#container_options_embroidery-puff').find('.switch').find('input').is(':disabled');

	for(var i = 0; i < colors.length; i++){
		var color = colors[i].substr(1);
		var thumb = '<input type="radio" id="embroidery-puff-' + color + '" name="option_embroidery-puff" value="embroidery-puff-' + color + '"' + (enabled ? '' : 'disabled="disabled"') + '>';
		var label = '<label style="background:#' + color + '" for="embroidery-puff-' + color + '"></label>';
		out += thumb + label;
	}

	return out;
};

window.Products.Embroidery.Snapback.prototype.selectPuffOptionColor = function(color){
	if(!color) return;
	$('#container_options_embroidery-puff').find('.switch').find('input').prop('checked', true);
	$('#option_embroidery-puff_colors').find('#embroidery-puff-' + color.split('#')[1]).prop('checked', true);
};

window.Products.Embroidery.Snapback.prototype.updatePuffOption = function(){
	// Use alternative behavior is the color picked is disabled
	var enabled = $('#container_options_embroidery-puff').find('.switch').find('input').is(':checked');

	if(enabled){
		// Get already selected color
		var checked_id = $('#option_embroidery-puff_colors').find('input:checked').attr('id');

		// Load new colors
		$('#option_embroidery-puff_colors').html(this.getPuffOption());

		// Reselect the same color or select the first one
		if($('#option_embroidery-puff_colors').find('#' + checked_id).length)
			$('#option_embroidery-puff_colors').find('#' + checked_id).first().get()[0].checked = true;
		else if($('#option_embroidery-puff_colors input[type=radio]').get()[0])
			$('#option_embroidery-puff_colors input[type=radio]').get()[0].checked = true;
	} else {
		// Get index of already selected color
		var checked_index = $('#option_embroidery-puff_colors').find('input:checked').index('#option_embroidery-puff_colors input[type=radio]');

		// Load new colors
		$('#option_embroidery-puff_colors').html(this.getPuffOption());

		// Reselect the same index or select the first one
		if($('#option_embroidery-puff_colors input[type=radio]').get()[checked_index])
			$('#option_embroidery-puff_colors input[type=radio]').get()[checked_index].checked = true;
		else if($('#option_embroidery-puff_colors input[type=radio]').get()[0])
			$('#option_embroidery-puff_colors input[type=radio]').get()[0].checked = true;
	}
}; 

window.Products.Embroidery.Snapback.prototype.getOptionsExtra = function(_option){
	var me = this;
	switch(_option) {
		case "color":
			return [];
		case "embroidery-puff":
			var out = [];
			var input = $('#option_embroidery-puff_colors').find('input:checked');
			if(input.length)
				out["embroidery-puff-color"] = '#' + input.val().split('embroidery-puff-')[1];
			return out;
		default:
			return [];
	}
};

window.Products.Embroidery.Snapback.prototype.handleOption = function(e){
	switch(e.data.option){
		case 'color':
			e.data.modelViewer.product.handleColorOption.call(this, e.data.modelViewer);
			break;
		case 'embroidery-puff':
			// Noop 
			break;
		default: 
			// Noop
	}
};

window.Products.Embroidery.Snapback.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	object.children[1].material.map = object.children[1].material.bumpMap;
	object.children[2].material.map = object.children[2].material.bumpMap;
	object.children[4].material.map = object.children[4].material.bumpMap;
	object.children[6].material.map = object.children[6].material.bumpMap;

	var color_1, color_2;

	// Make sure emissive is off for these
	object.children[1].material.emissive = new THREE.Color(0x000000);
	object.children[2].material.emissive = new THREE.Color(0x000000);
	object.children[3].material.emissive = new THREE.Color(0x000000);

	// Make sure bumpScale is the right value
	object.children[6].material.bumpScale = 0.002;
	object.children[1].material.bumpScale = 0.001;

	switch(color) {
		case 'black-neon_green':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("neon_green");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-neon_green");

			// Custom emissive for Neon Green
			var emissive = new THREE.Color("#304000");
			object.children[1].material.emissive = emissive;
			object.children[2].material.emissive = emissive;
			object.children[3].material.emissive = emissive;
			break;
		case 'black-neon_orange': // Disabled at the moment
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("orange");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'black-neon_pink':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("neon_pink");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-neon_pink");
			break;
		case 'black-purple': // Disabled at the moment
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("purple");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'black-red':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("red");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-red");
			break;
		case 'black-silver':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("silver");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-silver");
			break;
		case 'black-teal':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("teal");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-teal");
			break;
		case 'dark_heather-black':
			color_1	= me.getColor("dark_heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("black");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-black");

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'dark_heather-red':
			color_1	= me.getColor("dark_heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("red");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-red");

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'heather-black': // Disabled at the moment
			color_1	= me.getColor("heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("black");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'heather-navy': // Disabled at the moment
			color_1	= me.getColor("heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("navy");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'heather-purple': // Disabled at the moment
			color_1 = me.getColor("heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2 = me.getColor("purple");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'heather-red': // Disabled at the moment
			color_1	= me.getColor("heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("red");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'heather-royal': // Disabled at the moment
			color_1	= me.getColor("heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("royal");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong

			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'natural-black': // Disabled at the moment
			color_1	= me.getColor("natural");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("black");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'navy-red':
			color_1	= me.getColor("navy");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("red");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-red");
			break;
		case 'purple-gold':
			color_1	= me.getColor("purple");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("gold");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-gold");
			break;
		case 'royal-orange':
			color_1	= me.getColor("blue");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("orange");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-orange");
			break;
		case 'black':
			color_1	= me.getColor("black");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("black");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-black");
			break;
		case 'dark_grey': // Disabled at the moment
			color_1	= me.getColor("dark_grey");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("dark_grey");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'dark_heather':
			color_1	= me.getColor("dark_heather");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("dark_heather");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-dark_heather");

			object.children[1].material.map = modelViewer.product.textures[1];
			object.children[2].material.map = modelViewer.product.textures[1];
			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'dark_navy': // Disabled at the moment
			color_1	= me.getColor("dark_navy");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("dark_navy");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'green_camo':
			color_1	= me.getColor("black");
			object.children[3].material.color = color_1;
			object.children[4].material.color = color_1;

			color_2	= new THREE.Color("#CCC");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[6].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-black");

			object.children[1].material.map = modelViewer.product.textures[0];
			object.children[2].material.map = modelViewer.product.textures[0];
			object.children[6].material.map = modelViewer.product.textures[0];
			break;
		case 'heather_grey':
			color_1	= me.getColor("heather_grey");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("heather_grey");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-heather_grey");

			object.children[1].material.map = modelViewer.product.textures[1];
			object.children[2].material.map = modelViewer.product.textures[1];
			object.children[4].material.map = modelViewer.product.textures[1];
			object.children[6].material.map = modelViewer.product.textures[1];
			break;
		case 'maroon':
			color_1	= me.getColor("maroon");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("maroon");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-maroon");
			break;
		case 'natural': // Disabled at the moment
			color_1	= me.getColor("natural");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("natural");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'navy':
			color_1	= me.getColor("navy");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("navy");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-navy");
			break;
		case 'orange': // Disabled at the moment
			color_1	= me.getColor("orange");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("orange");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'purple': // Disabled at the moment
			color_1	= me.getColor("purple");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("purple");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'red':
			color_1	= me.getColor("red");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("red");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-red");
			break;
		case 'royal':
			color_1	= me.getColor("royal");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("royal");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-royal");
			break;
		case 'silver': // Disabled at the moment
			color_1	= me.getColor("silver");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("silver");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'spruce': // Disabled at the moment
			color_1	= me.getColor("spruce");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("spruce");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = color_2; // This is wrong
			break;
		case 'white':
			color_1	= me.getColor("white");
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;
			
			color_2	= me.getColor("white");
			object.children[1].material.color = color_2;
			object.children[2].material.color = color_2;
			object.children[3].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-white");

			// Custom bumpScale for the white
			object.children[6].material.bumpScale = 0.001;
			object.children[1].material.bumpScale = 0.001;
			break;
		case 'black-green_camo':
			color_1	= me.getColor("black");
			object.children[2].material.color = color_1;
			object.children[3].material.color = color_1;
			object.children[4].material.color = color_1;
			object.children[6].material.color = color_1;

			color_2	= new THREE.Color("#CCC");
			object.children[1].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-black");

			object.children[1].material.map = modelViewer.product.textures[0];
			break;
		case 'green_camo-black':
			color_1	= me.getColor("black");
			object.children[1].material.color = color_1;
			object.children[2].material.color = color_1;
			object.children[3].material.color = color_1;
			object.children[4].material.color = color_1;

			color_2	= new THREE.Color("#CCC");
			object.children[6].material.color = color_2;

			object.children[8].material.color = me.getColor("snap-black");

			object.children[6].material.map = modelViewer.product.textures[0];
			break;
	}

	object.children[1].material.needsUpdate = true;
	object.children[2].material.needsUpdate = true;
	object.children[4].material.needsUpdate = true;
	object.children[6].material.needsUpdate = true;
};

window.Products.Embroidery.Snapback.prototype.getPageFitDimensions = function(variant, scene){
	var data = this.static.preview_data.scenes[scene];
	var width = data.originalWidth;
	var height = data.originalHeight;
	return [width, height];
};

window.Products.Embroidery.Snapback.prototype.getSceneScale = function(_from, _to){
	var ratio = 0.61714285714285714285714285714286; // Had 0.5 before?
	if(_from == _to){
		return 1;
	} else if (_from == 'main'){
		return ratio;
	} else if(_from == 'back'){
		return 1/ratio;
	}
};

window.Products.Embroidery.Snapback.prototype.getColor = function(_name){
	colors = {
		"black": 0x0b0d0d,
		"neon_green": 0x9fbf00,
		"neon_pink": 0xbf1d4b,
		"red": 0x800608,
		"silver": 0x66665c,
		"teal": 0x007180,
		"dark_heather": 0x262320,
		"navy": 0x0a0b12,
		"purple": 0x10091f,
		"gold": 0xbf7900,
		"blue": 0x061840,
		"orange": 0x991700,
		"heather_grey": 0x808071,
		"maroon": 0x260d11,
		"royal": 0x0d1638,
		"white": 0xe5e5d3,
		"snap-black": 0x050606,
		"snap-neon_green": 0x99e52e,
		"snap-neon_pink": 0xcc5274,
		"snap-red": 0x991f21,
		"snap-silver": 0x808073,
		"snap-teal": 0x0a5466,
		"snap-dark_heather": 0x1f1c1a,
		"snap-gold": 0xcc8f00,
		"snap-orange": 0xbf2d13,
		"snap-heather_grey": 0x7a7a71,
		"snap-maroon": 0x140709,
		"snap-navy": 0x0a0b12,
		"snap-royal": 0x0e1938,
		"snap-white": 0xc9c5c0
	};

	return new THREE.Color(colors[_name]);
};